import Hero from "@/components/ui/Hero";
import CTABlock from "@/components/ui/CTABlock";
import ServiceCard from "@/components/ui/ServiceCard";
import { SERVICES } from "@/data/services";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function ServicesHub() {
    useDocumentTitle(
        "Pool Cage & Screen Repair Services Naples FL · A1 Screening",
        "All A1 Screening services in Naples and Southwest Florida — pool cage repair, rescreening, structural repair, lanai, screen doors, storm damage, condo screen repair."
    );
    return (
        <>
            <Hero
                eyebrow="Services"
                title="What We Fix"
                subtitle="From pool cages to condos, we screen it all. Free estimates, clean workmanship, family-owned since 1999."
            />
            <section className="a1-section">
                <div className="a1-container">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {SERVICES.map((s) => <ServiceCard key={s.slug} service={s} />)}
                    </div>
                </div>
            </section>
            <CTABlock />
        </>
    );
}
